import React from "react";
import { Col, Row, Typography } from "antd";
import AvatarPreview from "../profile/components/AvatarPreview";
import {
  convertUnixToPersianDate,
  convertNumToFa,
} from "../../constant/helper";

const { Paragraph } = Typography;

export default function SubscriberInfo({
  userInfo = {
    avatarImage: 3,
    name: "",
    description: "",
    education: "",
    workResume: "",
    categoryName: "",
    licenceNumber: "", // شماره پروانه
    licenceIssuedAt: "", //  تاریخ صدور پروانه
  },
}) {
  return (
    <>
      <div className="bottom-sheet-bg-holder">
        <div className="bottom-sheet-bg" />
      </div>
      <div className="bottom-sheet-content">
        <div className="avatar-holder">
          <div className="avatar lawyer-avatar">
            <AvatarPreview src={userInfo.avatarImage || 3} isSvg={false} />
          </div>
        </div>
        <div className="center-flex mb-10">
          <Paragraph className="rate-txt lawyer-name">
            {userInfo.name}
          </Paragraph>
        </div>
        {/* <div className="center-flex">
          <Paragraph className="rate-txt lawyer-description">
            {userInfo.description}
          </Paragraph>
        </div> */}

        <Row>
          <Col span={22} offset={1} className="lawyer-detail mb-30">
            <div>
              <span>نام و نام خانوادگی:</span>
              <b>
                <span> </span>
                {`${userInfo.name}`}
              </b>
            </div>
            {/* <div>
              <span>تحصیلات:</span>
              <b>{`  ${userInfo.education}`}</b>
            </div> */}
            <div>
              <span>تخصص‌های مرتبط :</span>
              <b>
                <span> </span>
                {`${userInfo.categoryName}`}
              </b>
            </div>
            <div>
              <span>شماره پروانه وکالت:</span>
              <b>
                <span> </span>
                {`${convertNumToFa(
                  userInfo.licenceNumber.toLocaleString("fa")
                )}`}
              </b>
            </div>
            <div>
              <span>تاریخ صدور پروانه وکالت:</span>

              <b>
                <span> </span>
                {convertNumToFa(
                  convertUnixToPersianDate(
                    userInfo.licenceIssuedAt,
                    "jYYYY/jMM/jDD"
                  ).toLocaleString("fa")
                )}
              </b>
            </div>

            {/* <div>
              <span>سوابق کاری:</span>
              <b>{`  ${userInfo.workResume}`}</b>
            </div> */}

            {/* <Paragraph>
              وکیل پایه دادگستری و عضو کانون وکلای استان تهران با بیش از 20 سال
              سابقه وکالت در زمینه کیفری (چک کیفری، خیانت در امانت، ممانعت از
              حق، تهدید و توهین، ایراد جرح و صدمات بدنی،..) و حقوقی ( دعاوی
              تقابل، خلع ید، ملک، چک حقوقی، انحلال شرکت...)
            </Paragraph> */}
          </Col>
        </Row>
      </div>
    </>
  );
}
